import {Component, OnInit} from '@angular/core';
import {ContentService} from '../service/content.service';
import {MessageService} from '../service/message.service';
import {TrackService} from '../service/track.service';
import {Track} from '../model/track';

@Component({
  selector: 'app-tracks',
  templateUrl: './tracks.component.html',
  styleUrls: ['./tracks.component.css']
})

export class TracksComponent implements OnInit {

  tracks: Track[];

  constructor(private contentService: ContentService,
              private trackService: TrackService,
              private messageService: MessageService) {
  }

  ngOnInit() {
    this.trackService.list().toPromise()
      .then(v => this.tracks = v)
      .catch(err => this.messageService.add(err));
  }

  onDeleteTrack(track: Track) {
    if (confirm('Do you want to remove this track? It will be removed from all related playlists.')) {
      this.trackService.delete(track.id)
        .subscribe(() => {
            let idx: number = this.tracks.indexOf(track);
            this.tracks.splice(idx, 1);
          }, err => this.messageService.addDefaultError(err)
        );
    }
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/tracks/tracks.component.ts